import { configHome, DataSource } from "@pub/config";
import placeholders from "@pub/placeholders";
import { ContentBlock, LatestArticle } from "@sphtech/dmg-design-system";
import {
  extractHomeContentData,
  HomeLayoutProps,
} from "@src/app/layouts/Home/Elements/utils";
import cx from "classnames";
import { ReactNode } from "react";

import styles from "./home.module.css";

type HomeMansonaryProps = {
  data: HomeLayoutProps["data"];
  dataSource: DataSource;
};

export default function HomeMansonaryLayout({
  data,
  dataSource,
}: HomeMansonaryProps) {
  const contentBlockItems = extractHomeContentData(data, dataSource);

  if (!!contentBlockItems?.items.length && contentBlockItems.items.length < 0) {
    return null;
  }

  const StoryColumn = contentBlockItems?.items.reduce<ReactNode[][]>(
    (acc, teaser, index: number) => {
      const columnIndex = index % 3;

      const itemComponent = (
        <div key={index} className={cx(styles.contentBlockItem)}>
          <LatestArticle
            key={index}
            {...teaser}
            mode="original"
            placeholders={placeholders}
          />
        </div>
      );

      if (acc[columnIndex]) {
        acc[columnIndex].push(itemComponent);
      }
      return acc;
    },
    [[], [], []],
  );

  return (
    !!contentBlockItems?.items.length && (
      <section className={cx(styles.bodyContainer, styles.masonaryContainer)}>
        <ContentBlock
          heading={contentBlockItems.title}
          cta={{
            name: "VIEW MORE",
            url: contentBlockItems.url,
            icon: configHome.viewMore?.icon,
          }}
          withDivider={configHome.headingDivider}
          isHeadingClickable={configHome.isHeadingClickable}
        >
          <div className={cx(styles.gutterHorizontal)}>
            <div className={cx(styles.contentBlockLayout)}>
              {StoryColumn &&
                StoryColumn.map((column, index) => (
                  <div key={index} className={cx(styles[`flow${index + 1}`])}>
                    {column}
                  </div>
                ))}
            </div>
          </div>
        </ContentBlock>
      </section>
    )
  );
}
